// extracted by mini-css-extract-plugin
export default {"btn":"btn__wAP4q","disabled":"disabled__sRZ0U","loader":"loader__N5PH1"};